
/* userdata generation */
export const PROJECT_DETAILS_USERDATA_GENERATION_ACTIVATE = 'PROJECT_DETAILS_USERDATA_GENERATION_ACTIVATE';
export const PROJECT_DETAILS_USERDATA_GENERATION_DEACTIVATE = 'PROJECT_DETAILS_USERDATA_GENERATION_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/actions/userdata-generation.ts